import { useCallback, useEffect, useState } from "react";
import { Card, Col, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { Maximize } from "react-feather";
import { useNavigate } from "react-router-dom";

const WidgetWrapper = ({ title, expandRoute, loading, children }) => {
  const navigate = useNavigate();
  const [fullscreen, setFullscreen] = useState(false);
  // const cachedChildren = useMemo(() => { return (<>{children}</>) }, [children]);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Escape" && fullscreen) {
        setFullscreen(false);
      }
    },
    [fullscreen]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [fullscreen, handleKeyDown]);

  return (
    <Col sm="6" xl="3" className="mb-0">
      <Card
        style={{
          minHeight: "380px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center m-0 p-3">
          <h4 className="text-dark">{title}</h4>
          {expandRoute && (
            <div>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="expand-tooltip-1">Expand</Tooltip>}
              >
                <Maximize
                  size={18}
                  className="cursor-pointer"
                  onClick={() => navigate(expandRoute)}
                />
              </OverlayTrigger>
            </div>
          )}
        </div>
        <div>{loading ? <Spinner /> : children}</div>
      </Card>
      {/* <Modal.Dialog
        show={true}
        fullscreen={fullscreen}
        bsPrefix="widget"
        scrollable={true}
        contentClassName="card mb-0"
      >
        <Modal.Header>
          <h4>{title}</h4>
          {
            fullscreen ?
              <Button
                variant="primary"
                onClick={() => {
                  setFullscreen(!fullscreen);
                }}
              >
                Close
              </Button>
              :
              <div>
                <Maximize
                  size={"2.0em"}
                  onClick={() => {
                    setFullscreen(!fullscreen);
                  }}
                  style={{cursor: "pointer"}}
                />
              </div>
          }
        </Modal.Header>

        <Modal.Body>{children}</Modal.Body>

     
      </Modal.Dialog> */}
    </Col>
  );
};

export default WidgetWrapper;
